import {opsApi} from 'services/apis'
import type {GetDocumentsByOpsOrderIdResponse} from 'types/orderTypes'
import {RESET_DOCUMENTS, SET_DOCUMENTS_LOADED, SET_DOCUMENTS_LOADING} from 'constants/actionTypes'
import type {AppDispatch} from 'services/store'
import type {RootAction} from 'reducers'

export const getDocumentsByOpsOrderId = async (opsOrderId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({type: SET_DOCUMENTS_LOADING})
      const response = await opsApi.get<GetDocumentsByOpsOrderIdResponse>(
        `orders/${opsOrderId}/documents`
      )

      dispatch({
        type: SET_DOCUMENTS_LOADED,
        payload: response
      })
      return response
    } catch {}
  }
}

export function resetDocumentsState(): RootAction {
  return {
    type: RESET_DOCUMENTS
  }
}
